const state = {
  boards: {
    byId: {},
    allIds: []
  },
  collaborators: {},
  defaultBoardId: "",
  selectedBoardId: "",
  boardsStatuses: {},
  boardsStatusesTranslationMap: {},
  boardsCustomFieldsDefinitions: {},
  customFieldsTranslationMap: {},
  boardChangelog: [],
  clientProfileSearchString: "",
  defaultFilters: {
    upcomingMilestones: {
      all: true,
      "past-due": false,
      active: false,
      upcoming: false,
      planned: false
    },
    activities: {
      all: true,
      "past-due": false,
      active: false,
      upcoming: false,
      planned: false
    },
    referrers: [],
    agents: [],
    collaborators: [],
    colors: []
  },
  clientProfiles: {
    byId: {},
    allIds: []
  },
  emailTemplates: {
    byId: {},
    allIds: []
  },
  checklistTemplates: {
    byId: {},
    allIds: []
  },
  inactiveTable: {
    inactiveClientProfiles: {
      byId: {},
      allIds: []
    },
    inactiveTableFilters: {
      orderBy: "",
      orderType: "",
      searchString: "",
      boardIds: []
    },
    totalInactive: 0
  },
  lists: {},
  campaigns: {},
  clientProfileIdsWithChanges: {},
  agentUsername: {}
};
export const defaultSelectedBoard = {
  id: "",
  name: "",
  default: false,
  owner: false,
  trackEmails: false,
  sortBy: "none"
};
export default state;